module.exports = __webpack_public_path__ + "img/arrow-next.b0b5a225.svg";